export enum wall_types{
    wall,
    door1,
    door2,
    door3,
    gate,
    hall
}